import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://register.educatory.ac/api';
// const API_URL = 'https://register.educatory.ac/api';

export const initializeRazorpay = () => {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
};

export const createOrder = async (orderData) => {
  try {
    const response = await axios.post(`${API_URL}/payments/create-order`, orderData, {
      withCredentials: true,
      credentials: 'include'
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
